import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { RFSReassignForm } from "@/features/rfs/RFSReassignForm";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function RFSReassign() {
  const { id } = useParams();

  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "RFS",
          },
          {
            href: "/rfs/rfs",
            label: "RFS",
          },
          {
            label: "Reassign RFS",
          },
        ]}
      />
      <H2>Reassign Form</H2>
      <RFSReassignForm id={id} />
    </>
  );
}
